import { createFileRoute, redirect } from '@tanstack/react-router'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'

// Redirector: /home -> /org/$orgId/home
export const Route = createFileRoute('/_authenticated/_dashboard/home/')({
  component: () => null,
  beforeLoad: async () => {
    const store = useSelectedTenantStore.getState()
    if (store.selectedTenantId) {
      throw redirect({
        to: '/org/$orgId/home',
        params: { orgId: store.selectedTenantId },
        search: (prev) => prev,
      })
    }
    throw redirect({ to: '/select-tenant' })
  },
})
